import React, { useState, useEffect } from 'react';
import FormInput from './FormInput';
import TagSelector from '../../TagSelector';
import { coins } from '../../../utils/api';

const BasicInformation = ({
  formData,
  handleChange,
  handleFocus,
  handleBlur,
  getDisplayValue,
  setFormData
}) => {
  const [possibleStatuses, setPossibleStatuses] = useState([]);

  useEffect(() => {
    const fetchStatuses = async () => {
      try {
        const statuses = await coins.getPossibleStatuses();
        setPossibleStatuses(statuses);
      } catch (err) {
        console.error('Failed to fetch possible statuses:', err);
      }
    };
    fetchStatuses();
  }, []);

  return (
    <div className="space-y-4">
      <div className="grid grid-cols-1 sm:grid-cols-3 lg:grid-cols-5 gap-4">
      <FormInput
        label="User Coin ID"
        name="user_coin_id"
        value={formData.user_coin_id}
        onChange={handleChange}
        placeholder="YYYY-X"
        required
      />

      <FormInput
        label="Country"
        name="country"
        value={formData.country}
        onChange={handleChange}
        autocomplete="off"
      />

      <FormInput
        label="Year"
        name="year"
        value={formData.year || ''}
        onChange={handleChange}
        required
      />

      <FormInput
        label="Mint Mark"
        name="mint_mark"
        value={formData.mint_mark}
        onChange={handleChange}
      />

      <FormInput
        label="Denomination"
        name="denomination"
        value={formData.denomination}
        onChange={handleChange}
        required
      />

      </div>
      
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
        <FormInput
          label="Variety"
          name="variety"
          value={formData.variety}
          onChange={handleChange}
        />

        <FormInput
          label="Grade"
          name="grade"
          value={formData.grade}
          onChange={handleChange}
        />

        <div>
        <label htmlFor="cac_sticker" className="block text-sm font-medium text-gray-700 mb-2">
          CAC Sticker
        </label>
        <select
          id="cac_sticker"
          name="cac_sticker"
          value={formData.cac_sticker || 'none'}
          onChange={handleChange}
          className="block w-full shadow-sm focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm border-gray-300 rounded-md"
        >
          <option value="none">None</option>
          <option value="green">Green</option>
          <option value="gold">Gold</option>
        </select>
      </div>

        <FormInput
          label="PCGS Number"
          name="pcgs_number"
          value={formData.pcgs_number || ''}
          onChange={handleChange}
        />
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-4 gap-4">
        <div>
          <label htmlFor="status" className="block text-sm font-medium text-gray-700 mb-2">
            Status
          </label>
          <select
            id="status"
            name="status_name"
            value={formData.status_name || ''}
            onChange={handleChange}
            className="block w-full shadow-sm focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm border-gray-300 rounded-md"
          >
            <option value="">Select Status</option>
            {possibleStatuses.map(status => (
              <option 
                key={typeof status === 'object' ? status.name : status} 
                value={typeof status === 'object' ? status.name : status}
                style={status.color ? { backgroundColor: status.color } : {}}
              >
                {typeof status === 'object' ? status.name : status}
              </option>
            ))}
          </select>
        </div>
        
        <div className="col-span-3">
          <label htmlFor="tags" className="block text-sm font-medium text-gray-700 mb-2">
            Tags
          </label>
          <TagSelector
            selectedTags={formData.tags}
            onChange={(newTags) => setFormData(prev => ({ ...prev, tags: newTags }))}
            className="w-full"
          />
        </div>
      </div>
    </div>
  );
};

export default BasicInformation;
